import {css} from 'styled-components'
// tslint:disable-next-line:no-duplicate-imports
import type {DefaultTheme} from 'styled-components'

const getElevatedButtonSurface = ({theme}: {theme: DefaultTheme}) =>
    theme.variant === 'v26'
        ? theme.colors.background.tertiary
        : theme.colors.background.primary

const WhiteButton = css`
    background-color: ${getElevatedButtonSurface};
    border-color: ${getElevatedButtonSurface};
`

export default WhiteButton
